var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodiatricSurgery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #fff;\n      }\n\n      .st0, .st1, .st2 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: .8px;\n      }\n\n      .st0, .st1, .st3 {\n        fill: none;\n      }\n\n      .st1, .st4, .st2, .st3 {\n        stroke: #4c5b66;\n      }\n\n      .st4 {\n        fill: #ffd2b0;\n        stroke-width: .9px;\n      }\n\n      .st2 {\n        fill: #b56d16;\n      }\n\n      .st3 {\n        stroke-dasharray: .6 .6;\n        stroke-width: .6px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.8,8l2-2.3c-.2-.1-.3-.2-.5-.3-2.9-1.5-6.5-.4-8.1,2.6-1.5,3-.4,6.6,2.5,8.2s6.5.4,8.1-2.6c1.1-2.1.8-4.6-.5-6.4l-1.9,2.2-1.6-1.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.6,7.9l1.8,1.5,1.9-2.2c-.4-.6-1.1-1.2-1.7-1.6l-2,2.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.6,13.7s2,1.2,3.1,0l1.9-2.2-.7-.6,1.8-2-1.1-.9-5,5.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.8,15.8c.1-.1,0,0,.2-.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,16.6s.7.2,1.5,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.5,7.4c.1,1,.4,4.1.2,7.5,0,1.4-.8,3-2,4-1.2.9-3.2,1.9-4,2.2-.8.3-3.3,2.1-4.7,2.4-1.3.3-2.6.9-4.3.9-.8,0-1.2.4-1.2.9,0,.5.1,1.7,2.2,1.7s1.6-.2,2-.2.9.5,2.3.5c2.6,0,5.7-1,7.5-1s2.7.2,3.7.5c1,.3,1.9.5,3.7.5s1.8-.1,2.3-.6c.6-.6,1.1-1.9.6-3.8-.3-1.4-.7-2.4-.7-4,0-1.6.2-4.2.4-5.8.2-1.3.7-4.5.9-5.7,0-.2-.1-.4-.3-.4l-4.2-1.8-4.1,1.8c-.2,0-.4.2-.3.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.6,19.1c.2,1,.8,2,1.5,2.7.7.8,1.7,1.3,2.7,1.6,1,.3,2.2.3,3.2,0,1.1-.3,2-.8,2.8-1.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.4,26.4c.2-.6.2-1.3,0-2-.2-.6-.6-1.2-1.1-1.7-.5-.5-1.1-.8-1.8-1-.7-.2-1.4-.2-2,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodiatricSurgery);
export default __webpack_public_path__ + "static/media/podiatric_surgery.1baf31206765c967a103f7c287fcf7e7.svg";
export { ForwardRef as ReactComponent };